/**
 * Copyright (c) 2019, Tidepool Project
 *
 * This program is free software; you can redistribute it and/or modify it under
 * the terms of the associated License, which is identical to the BSD 2-Clause
 * License as published by the Open Source Initiative at opensource.org.
 *
 * This program is distributed in the hope that it will be useful, but WITHOUT
 * ANY WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS
 * FOR A PARTICULAR PURPOSE. See the License for more details.
 *
 * You should have received a copy of the License along with this program; if
 * not, you can obtain one from Tidepool Project at tidepool.org.
 */

import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Popover from '@material-ui/core/Popover';
import Typography from '@material-ui/core/Typography';
import Info from '@material-ui/icons/Info';

const useStyles = makeStyles(theme => ({
  typography: {
    padding: theme.spacing(2),
  },
}));

// A component which comprises the help popups for each loop setting, shown on the screen currently as an (i)
const HelpPopup = (props) => {
  const classes = useStyles();
  const [anchorEl, setAnchorEl] = React.useState(null);

  function handleClick(event) {
    setAnchorEl(event.currentTarget);
  }

  function handleClose() {
    setAnchorEl(null);
  }

  const open = Boolean(anchorEl);
  
  // If wondering why there is a split function based on the '*' character, that is if wanting to split a message by lines, when writing the 
  // popup message you can just add a '*' where you want a line break
  return (
    <div>
      <Info style={{fontSize: '18px', color: '#4f6a92'}} onClick={handleClick}/>
      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
      >
        <div style={{width: '350px'}} className={classes.typography}>
          {props.helpMessage && props.helpMessage.split('*').map((item, key) => {
            return <Typography key={key}>{item}</Typography>
          })}
        </div>
      </Popover>
    </div>
  );
}

export default HelpPopup;